import { PageContainer } from "src/components/organisms/contents";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useViewport } from "src/common/hooks/ViewPort";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ToggleBtn } from "src/components/atoms/ToggleButton/ToggleBtn";
import {
  useUpdateUser,
  useUserRegister,
} from "src/common/hooks/useUserRegister";

export const AlertSetting = () => {
  const navi = useNavigate();
  const { px } = useViewport();

  const { data: userAlert } = useUserRegister();

  const { mutateAsync: updateUserAlert } = useUpdateUser();

  const [isAllAlert, setIsAllAlert] = useState<boolean>(true);
  const [isFamilyAlert, setIsFamilyAlert] = useState<boolean>(
    userAlert?.familyAlarmYn ?? true
  );
  // const [isReward, setIsReward] = useState<boolean>(true);
  const [isPillAlert, setIsPillAlert] = useState<boolean>(
    userAlert?.mediAlarmYn ?? true
  );

  const isAll = () => {
    const newAll = !isAllAlert;
    setIsAllAlert(newAll);
    setIsFamilyAlert(newAll);
    setIsPillAlert(newAll);
  };

  // 개별 알림 상태에 따라 전체 알림 자동 업데이트
  useEffect(() => {
    if (isFamilyAlert && isPillAlert) {
      setIsAllAlert(true);
    } else {
      setIsAllAlert(false);
    }
  }, [isFamilyAlert, isPillAlert]);

  const handleSave = async () => {
    await updateUserAlert({
      familyAlarmYn: isFamilyAlert,
      mediAlarmYn: isPillAlert,
    });

    navi("/alert");
  };

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader title="알림 설정" onClickArrow={handleSave} />

        <div
          style={{
            marginTop: px(12),
            background: "#FFFFFF",
            borderRadius: px(14),
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            padding: px(14),
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 16,
          }}
        >
          <div
            style={{
              color: "#404040",
              fontSize: px(18),
              fontWeight: 700,
              lineHeight: `${px(28)}px`,
            }}
          >
            전체 알림 받기
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#737373",
                fontSize: px(16),
                fontWeight: 500,
                lineHeight: `${px(24)}px`,
              }}
            >
              전체 알림 받기
            </div>
            <ToggleBtn isActive={isAllAlert} setIsActive={isAll} />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#737373",
                fontSize: px(16),
                fontWeight: 500,
                lineHeight: `${px(24)}px`,
              }}
            >
              가족 활동 상태 알림
            </div>
            <ToggleBtn
              isActive={isFamilyAlert}
              setIsActive={setIsFamilyAlert}
            />
          </div>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#737373",
                fontSize: px(16),
                fontWeight: 500,
                lineHeight: `${px(24)}px`,
              }}
            >
              리워드 알림
            </div>
            <ToggleBtn isActive={isReward} setIsActive={setIsReward} />
          </div> */}
        </div>

        <div
          style={{
            marginTop: px(12),
            background: "#FFFFFF",
            borderRadius: px(14),
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            padding: px(14),
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: 16,
          }}
        >
          <div
            style={{
              color: "#404040",
              fontSize: px(18),
              fontWeight: 700,
              lineHeight: `${px(28)}px`,
            }}
          >
            건강 루틴 알림
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: "#737373",
                fontSize: px(16),
                fontWeight: 500,
                lineHeight: `${px(24)}px`,
              }}
            >
              복약 기록 알림
            </div>
            <ToggleBtn isActive={isPillAlert} setIsActive={setIsPillAlert} />
          </div>
        </div>
      </>
    </PageContainer>
  );
};
